import { RoleType } from '../../../models/Role'
import { type CustomerSeats } from '../../../store/plan/plan'
import { ASSISTANT_SEATS_NOT_OFFERED } from '../assistantSeats'
import { type BulkCsvRow } from './bulkCsvRows'

export type BulkRowStatus = 'ready' | 'seatNeeded' | 'invalid'

export interface BulkPreviewRow {
  row: BulkCsvRow
  status: BulkRowStatus
}

export interface BulkPoolPreview {
  used: number
  left: number
  shortage: number
}

export interface BulkSeatPreview {
  rows: BulkPreviewRow[]
  readyCount: number
  rowCount: number
  general: BulkPoolPreview
  sidecar: BulkPoolPreview
}

const _STATUS_ORDER: Record<BulkRowStatus, number> = { ready: 0, seatNeeded: 1, invalid: 2 }

export const getBulkSeatPreview = (rows: BulkCsvRow[], seats: CustomerSeats, assistantOffered: boolean): BulkSeatPreview => {
  const pools = {
    general: { used: 0, left: seats.general.available, shortage: 0 },
    sidecar: { used: 0, left: seats.sidecar.available, shortage: 0 },
  }

  const previewRows = rows.map((row): BulkPreviewRow => {
    if (row.errors.length > 0) {
      return { row, status: 'invalid' }
    }
    const pool = row.seatType === RoleType.SIDECAR ? pools.sidecar : pools.general
    if (pool.left === 0) {
      if (row.seatType === RoleType.SIDECAR && !assistantOffered) {
        return { row: { ...row, errors: [ASSISTANT_SEATS_NOT_OFFERED] }, status: 'invalid' }
      }
      pool.shortage += 1
      return { row, status: 'seatNeeded' }
    }
    pool.left -= 1
    pool.used += 1
    return { row, status: 'ready' }
  })

  const sortedRows = [...previewRows].sort((a, b) => _STATUS_ORDER[a.status] - _STATUS_ORDER[b.status] || a.row.index - b.row.index)

  return {
    rows: sortedRows,
    readyCount: previewRows.filter((previewRow) => previewRow.status === 'ready').length,
    rowCount: previewRows.length,
    general: pools.general,
    sidecar: pools.sidecar,
  }
}
